module.exports = __webpack_public_path__ + "static/media/4_multifiber_A_aqua_square.0a6d50f1.png";